import { api } from './client.js';

export async function register({ email, password, full_name }) {
  return api.post('/auth/register', { email, password, full_name });
}

export async function login({ email, password }) {
  const form = new URLSearchParams({ username: email, password });
  return api.post('/auth/login', form, {
    isForm: true,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
}

export async function me() {
  return api.get('/users/me');
}
